(function(){
    angular.module('tmx-app').directive('tmxGeofenceInput',[tmxGeofenceInput]);
	
    function tmxGeofenceInput(){
        var directive={
            restrict:'E'
        };
        directive.controller=["$scope","$mdDialog","$state","GeofenceService","tmxUtility",tmxGeofenceInputCtrl];
        directive.controllerAs="tmxGeofenceInputCtrl";
        directive.scope={
            value:"=",
            label:"@",
            name:"@",
            gridData:"=",
            form:"=",
            disabledNodes:"=",
            locations: "=",
            geofencePoints: "=",
            effectiveStartDate: "=",
            effectiveEndDate: "=",
            geofenceArray: "=",
            readonly: '@',
            disabled: '=',
        };
        directive.replace="true";
        directive.templateUrl="common/directives/tmxgeofenceinput/tmxgeofenceinput.html";
        return directive;
    }

    function tmxGeofenceInputCtrl($scope,$mdDialog,$state,GeofenceService,tmxUtility){
        var vm=this;
        vm.scope=$scope;
        var exists=tmxUtility.exists;
        function selectItem(id){
            for(var i=0;i<$scope.gridData.data.length;i++){
                if($scope.gridData.data[i].GeofenceId == id) {
                    $scope.selectedItem=$scope.gridData.data[i];
                    break;
                }
            } 
        }
        if(exists($scope.value))
            selectItem($scope.value);

        vm.geofenceGridDialog=function(ev){            
            $mdDialog.show({
                multiple: true,
                locals:{selectedItem: angular.copy($scope.selectedItem), gridData: $scope.gridData, disabledNodes:$scope.disabledNodes, locations:$scope.locations},
                controller: ["$scope", "$mdDialog", "$state",'GeofenceService','selectedItem','gridData','tmxUtility','disabledNodes','locations',DialogController],
                controllerAs: 'dialogCtrl',                
                template: '<md-dialog ng-cloak flex="80"><form><md-dialog-content><kendo-grid id="grid" class="popUpGrid" options="dialogCtrl.mainGridOptions"></kendo-grid>    </md-dialog-content>    <md-dialog-actions layout="row">      <!--md-button class="primary-button" ng-click="hide()">       Filter      </md-button-->    </md-dialog-actions>  </form></md-dialog>',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose:true
            })
                .then(function(dataItem){
                    $scope.selectedItem=dataItem;
                    $scope.value=dataItem.GeofenceId;
                    $scope.effectiveStartDate = dataItem.EffectiveStartDate;
                    $scope.effectiveEndDate = dataItem.EffectiveEndDate;
                    $scope.geofencePoints = dataItem.GeofencePoints;
                    if(angular.isDefined($scope.geofenceArray)) {
                        $scope.geofenceArray={
                            GeofenceId:dataItem.GeofenceId,
                            GeofencePoints:dataItem.GeofencePoints,
                            EffectiveStartDate:dataItem.EffectiveStartDate,
                            EffectiveEndDate:dataItem.EffectiveEndDate,

                        }
                    }
                });
        }

        function value(){
            return $scope.value;
        }
        function change(newValue,oldValue){
            if( (exists(newValue) || exists(oldValue)) && newValue != oldValue){
                selectItem(newValue);
            }
        }
        $scope.$watch(value,change);
    }

    function DialogController($scope, $mdDialog,$state,GeofenceService,selectedItem,gridData,tmxUtility,disabledNodes,locations) {
        var obj=this;
        obj.Locations=locations;
        obj.date = new Date().toJSON();
        obj.disabledItems=[];
        obj.formatGeofenceName=function(dataitem) {
            if(dataitem.GeofenceName.length>10) {
                return dataitem.GeofenceName.slice(0,10)+"...";
            }
            return dataitem.GeofenceName;
        }

        obj.getGeofenceCode=function(dataitem) {
            if(dataitem.GeofenceCode!=null && angular.isDefined(dataitem.GeofenceCode)) {
                return dataitem.GeofenceCode;
            }
            return "N/A";
        }

        obj.getLocation=function(dataitem){  
            if(dataitem.LocationId!=null && angular.isDefined(dataitem.LocationId)) {
                for (var i = obj.Locations.length - 1; i >= 0; i--) {
                    if(obj.Locations[i].LocationId==dataitem.LocationId)
                        return obj.Locations[i].LocationName;
                }
            }

            return "N/A";
        }

        obj.mainGridOptions = {
            dataSource: {
                transport: {
                    read: function(o){                                                
                        GeofenceService.getByParams(o, true, '/GetGeofenceList').then(function (response) {                                                    
                            o.success(response)
                        });
                    },

                    dataType: "json"
                },
                schema: {
                    data: "data",
                    total: "Total"
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
            
            sort:  [{field: "GeofenceName", dir: "asc"}],
            },
            pageable: {
                refresh: true,
                pageSizes: true,
                pageSize: 10,
                buttonCount: 5
            },
            pdf: {
                allPages: true,
                fileName: "Geofences.pdf"
            },
            excel: {
                allPages: true,
                fileName: "Geofences.xlsx"
            },
            sortable: true,
            scrollable: false,            
            filterable: {
                extra: false,                              
            },       
            rowTemplate: "<tr data-uid='#= uid #' ng-class=\"{'deleted-row': dialogCtrl.isStatusActive(dataItem)}\"><td><md-button class='tmx-primary-text' ng-disabled='dialogCtrl.isStatusActive(dataItem)'> \{\{dialogCtrl.formatGeofenceName(dataItem)\}\}   <md-tooltip md-direction='top'>#=GeofenceName#</md-tooltip>  </md-button></td><td> \{\{dialogCtrl.getGeofenceCode(dataItem)\}\}   </td><td> \{\{dialogCtrl.getLocation(dataItem)\}\} </td><td> \{\{dialogCtrl.status(dataItem)\}\}   </td></tr>",
            columns: GeofenceService.columns
        };
        obj.mainGridOptions.dataBound= onDataBound;  
        obj.mainGridOptions.selectable=true;
        obj.mainGridOptions.preventDefault=true;  
        obj.getLookupName=GeofenceService.getLookupName;
        obj.getGeofenceName=GeofenceService.formatGeofenceName;
        var applyClassOnRows=tmxUtility.applyClassOnRows;
        var findItems=tmxUtility.findItems;
        var exists=tmxUtility.exists;
        var currentParentId;

        obj.mainGridOptions.change= function(e) {
            var selectedRows = this.select();
            var item=this.dataItem(selectedRows[0]);
            if(obj.disabledItems.length<=0)// if no disabled selection then just return the clicked item
                $scope.hide(item);
            else if (obj.disabledItems.length>0){//otherwise, only if there are some disabled items then see if current item is one of disabled items
                var isDisabled=findItems("GeofenceId",item.GeofenceId,obj.disabledItems).length>0;
                if(isDisabled){//if yes then unselect it and select the previous deselected item
                    applyClassOnRows(e.sender,"GeofenceId",item.GeofenceId,"k-state-selected k-state-selecting",true);
                    if(exists(selectedItem))
                        applyClassOnRows(e.sender,"GeofenceId",selectedItem.GeofenceId,"k-state-selected k-state-selecting");
                }            
                else{//else it  means item is valid to return so don't hesitate
                    $scope.hide(item);
                }
            }
        };

        $scope.hide = function(item) {
            $mdDialog.hide(item);
        };

        function onDataBound(arg) {
            if(exists(selectedItem)){
                applyClassOnRows(arg.sender,"GeofenceId",selectedItem.GeofenceId,"k-state-selected k-state-selecting");
            }
    
            function deselect(item){
                obj.disabledItems.push(item);
            }
            if(exists(disabledNodes))
                disabledNodes.forEach(deselect);
      
        }
        function isValidLoc(loc){
            return exists(loc) && exists(loc.GeofenceId);
        }
  
    }

})();